<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1135" height="1668" viewBox="0 0 1135 1668" fill="none">
    
    <!--

    Индикатор id=red-indicator
    Установить значения [riH1] и [riH2] соответственно уровню снижения/роста по таблице:
    0.6 — [riH1]=223  / [riH2]=135
    0.7 — [riH1]=309  / [riH2]=223
    0.8 — [riH1]=396  / [riH2]=310
    0.9 — [riH1]=483  / [riH2]=397
    1 —   [riH1]=570  / [riH2]=483
    1.1 — [riH1]=657  / [riH2]=570
    1.2 — [riH1]=744  / [riH2]=657
    1.3 — [riH1]=831  / [riH2]=744
    1.4 — [riH1]=918  / [riH2]=831
    1.5 — [riH1]=1005 / [riH2]=918

    Стрелка индикатора:
    [arrow06] — [arrow09], [arrow1], [arrow11] - [arrow15]
    Установить в hidden все, кроме того, стрелку которого нужно показать

      -->
    <rect width="1135" height="1550" fill="white"/>
    <line x1="361" y1="814.5" x2="964" y2="814.5" stroke="#99C0DD"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="17"
          font-weight="bold" letter-spacing="0.01em"><tspan x="361" y="795.617">Id</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="17"
          font-weight="bold" letter-spacing="0.01em"><tspan x="402" y="796.342">Комплексный индикатор спроса на выпускников</tspan></text>
    <rect x="914" y="766" width="50" height="48" fill="#00599B" fill-opacity="0.28"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="24" font-weight="bold" letter-spacing="0.01em"><tspan x="940" y="798.56">{{
        getMaData.i1
      }}</tspan></text>
    <line x1="361" y1="1122.5" x2="964" y2="1122.5" stroke="#99C0DD"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="17"
          font-weight="bold" letter-spacing="0.01em"><tspan x="361" y="1103.62">IS</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="17"
          font-weight="bold" letter-spacing="0.01em"><tspan x="402" y="1104.34">Комплексный индикатор предложения выпускников</tspan></text>
    <rect x="914" y="1074" width="50" height="48" fill="#00599B" fill-opacity="0.28"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="bold" letter-spacing="0.01em"><tspan x="940" y="1102.8">{{
        getMaData.i2
      }}</tspan></text>
    <line x1="361" y1="1206.5" x2="1104" y2="1206.5" stroke="#00599B"/>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="17"
          font-weight="bold" letter-spacing="0.01em"><tspan x="361" y="1187.62">KI</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="17"
          font-weight="bold" letter-spacing="0.01em"><tspan x="402" y="1188.34">Комплексный индикатор изменения потребности в выпускниках</tspan></text>
    <rect x="984" y="1158" width="50" height="48" fill="#00599B" fill-opacity="0.78"/>
    <rect x="1054" y="1158" width="50" height="48" fill="#00599B" fill-opacity="0.28"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="white" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="24" font-weight="bold" letter-spacing="0.01em"><tspan x="1009" y="1190">{{
        getMaData.di0
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="18" font-weight="500" letter-spacing="0.01em"><tspan x="1080" y="1188.59">{{
        getMaData.p0
      }}</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="1038.01" y="1191.2">-</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan xmlns="http://www.w3.org/2000/svg" x="1042" y="1152.22">Точность<title>Штраф за недостаточную точность, применяемый в случае низкой репрезентативности значений показателя, на основе которого рассчитывается частный индикатор (макс. штраф — 2 единицы). Для комплексных индикаторов штраф за точность применяется при наличии разнонаправленных сигналов частных индикаторов.</title></tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="Red Hat Text" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan x="1101" data-tooltip="Штраф за недостаточную точность, применяемый в случае низкой репрезентативности значений показателя, на основе которого рассчитывается частный индикатор (макс. штраф — 2 единицы). Для комплексных индикаторов штраф за точность применяется при наличии разнонаправленных сигналов частных индикаторов." y="1147.28">?</tspan></text>
    <path d="M705 660L705 662C705 666.418 708.582 670 713 670L722 670" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M929 660L929 662C929 666.418 925.418 670 921 670L767 670" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M730 681L730 678C730 673.582 726.418 670 722 670L716 670" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M730 681L730 678C730 673.582 733.582 670 738 670L769 670" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <line x1="361" y1="730.5" x2="908" y2="730.5" stroke="#99C0DD"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="bold" letter-spacing="0.01em"><tspan x="361" y="696.1">ISP</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="bold" letter-spacing="0.01em"><tspan x="402" y="696.1">Комплексный индикатор</tspan>
      <tspan x="402" y="712.6">изменения спроса на выпускников</tspan></text>
    <rect x="844" y="682" width="50" height="48" fill="#00599B" fill-opacity="0.28"/>
    <rect x="774" y="682" width="50" height="48" fill="#DEE9F2"/>
    <rect x="705" y="682" width="50" height="48" fill="#00599B" fill-opacity="0.13"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="bold" letter-spacing="0.01em"><tspan x="869" y="712.8">{{
        getMaData.i120
      }}</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="715.2">=</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="715.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="712.8">{{
        getMaData.p120
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="600" letter-spacing="0.01em"><tspan x="730" y="712.8">{{
        getMaData.di120
      }}</tspan></text>
    <line x1="28" y1="455.5" x2="337" y2="455.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="441.16">Среднегодовой темп экон. роста
</tspan></text>
    <rect x="275" y="417" width="62" height="38" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" letter-spacing="0.01em" font-weight="500"
          font-size="16" font-family="Raleway" style="white-space: pre" xml:space="preserve" fill="#263238"><tspan y="441.04" x="305">{{
        $scripts.TableJs.checkValueWithNullAndReturnND(getMaData.d121, 1, 'float', true, 'н.д.', '', (v) => v + '%')
      }}</tspan></text>
    <line x1="361" y1="455.5" x2="929" y2="455.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="439.685">ISP1</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="402" y="439.685">Индикатор экономического роста
</tspan></text>
    <rect x="844" y="417" width="50" height="38" fill="#DCE4E8"/>
    <rect x="774" y="417" width="50" height="38" fill="#ECF2F4"/>
    <rect x="705" y="417" width="50" height="38" fill="#ECF2F4"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="18" font-weight="500" letter-spacing="0.01em"><tspan x="869" y="441.92">{{
        getMaData.i121
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="445.2">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="445.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#78909C" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="440.04">{{
        getMaData.p121
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="902" y="451.22">{{
        Number.isNaN(Number(this.getMaData.w121)) ?
          getMaData.w121 : Math.round((getMaData.w121 + Number.EPSILON) * 10) / 10 + '%'
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="730" y="440.04">{{
        getMaData.di121
      }}</tspan></text>
    <line x1="361" y1="505.5" x2="929" y2="505.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="489.685">ISP2</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="402" y="489.685">Индикатор инвестпроектов
</tspan></text>
    <rect x="844" y="467" width="50" height="38" fill="#DCE4E8"/>
    <rect x="774" y="467" width="50" height="38" fill="#ECF2F4"/>
    <rect x="705" y="467" width="50" height="38" fill="#ECF2F4"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="18" font-weight="500" letter-spacing="0.01em"><tspan x="869" y="491.92">{{
        getMaData.i122
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="495.2">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="495.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#78909C" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="490.04">{{
        getMaData.p122
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="902" y="501.22">{{
        Number.isNaN(Number(this.getMaData.w122)) ?
          getMaData.w122 : Math.round((getMaData.w122 + Number.EPSILON) * 10) / 10 + '%'
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="730" y="490.04">{{
        getMaData.di122
      }}</tspan></text>
    <line x1="361" y1="555.5" x2="929" y2="555.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="539.685">ISP3</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="402" y="539.685">Индикатор базовых потребителей
</tspan></text>
    <rect x="844" y="517" width="50" height="38" fill="#DCE4E8"/>
    <rect x="774" y="517" width="50" height="38" fill="#ECF2F4"/>
    <rect x="705" y="517" width="50" height="38" fill="#ECF2F4"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="18" font-weight="500" letter-spacing="0.01em"><tspan x="869" y="541.92">{{
        getMaData.i123
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="545.2">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="545.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#78909C" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="540.04">{{
        getMaData.p123
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="902" y="551.22">
      {{
        Number.isNaN(Number(this.getMaData.w123)) ?
          getMaData.w123 : Math.round((getMaData.w123 + Number.EPSILON) * 10) / 10 + '%'
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="730" y="540.04">{{
        getMaData.di123
      }}</tspan></text>
    <line x1="361" y1="605.5" x2="929" y2="605.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="589.685">ISP4</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="402" y="589.685">Индикатор ожиданий работодателей
</tspan></text>
    <rect x="844" y="567" width="50" height="38" fill="#DCE4E8"/>
    <rect x="774" y="567" width="50" height="38" fill="#ECF2F4"/>
    <rect x="705" y="567" width="50" height="38" fill="#ECF2F4"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="18" font-weight="500" letter-spacing="0.01em"><tspan x="869" y="591.92">{{
        getMaData.i124
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="595.2">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="595.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#78909C" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="590.04">{{
        getMaData.p124
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="902" y="601.22">{{
        Number.isNaN(Number(this.getMaData.w124)) ? getMaData.w124
          : Math.round((getMaData.w124 + Number.EPSILON) * 10) / 10 + '%'
      }}
      </tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="730" y="590.04">{{
        getMaData.di124
      }}</tspan></text>
    <line x1="361" y1="655.5" x2="929" y2="655.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="639.685">ISP5</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="402" y="639.685">Индикатор ожиданий абитуриентов
</tspan></text>
    <rect x="844" y="617" width="50" height="38" fill="#DCE4E8"/>
    <rect x="774" y="617" width="50" height="38" fill="#ECF2F4"/>
    <rect x="705" y="617" width="50" height="38" fill="#ECF2F4"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#78909C" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em">
      <tspan x="799" y="640.04">{{ getMaData.p125 }}</tspan>
    </text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="18" font-weight="500" letter-spacing="0.01em">
      <tspan x="869" y="641.92">{{ getMaData.i125 }}</tspan>
    </text>
    <text
      fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
      font-weight="500" letter-spacing="0.01em">
      <tspan x="758.007" y="645.2">-</tspan>
    </text>
    <text
      fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
      font-weight="500" letter-spacing="0.01em">
      <tspan x="827.258" y="645.2">=</tspan>
    </text>
    <text fill="#78909C" xml:space="preserve" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em">
      <tspan x="902" y="651.22">
        {{
          Number.isNaN(Number(this.getMaData.w125)) ?
            getMaData.w125 : Math.round((getMaData.w125 + Number.EPSILON) * 10) / 10 + '%'
        }}
      </tspan>
    </text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="730" y="640.04">{{
        getMaData.di125
      }}</tspan></text>
    <line x1="28" y1="505.5" x2="337" y2="505.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="491.16">% новых мест по инвестпроектам
</tspan></text>
    <rect x="275" y="467" width="62" height="38" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="305" y="491.04">{{
        $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getMaData.d122) ? (getMaData.d122 === 'н.д.' ? 'н.д.' : 'x') : getMaData.d122, 1, 'float', true, 'н.д.', '', (v) => v + '%')
      }}</tspan></text>
    <line x1="28" y1="555.5" x2="337" y2="555.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="541.16">Прирост базовых потребителей
</tspan></text>
    <rect x="275" y="517" width="62" height="38" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="305" y="541.04">{{
        $scripts.TableJs.checkValueWithNullAndReturnND(getMaData.d123, 1, 'float', true, 'н.д.', '', (v) => v + '%')
      }}</tspan></text>
    <line x1="28" y1="605.5" x2="337" y2="605.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="591.16">Ожидаемый прирост потребности
</tspan></text>
    <rect x="275" y="567" width="62" height="38" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="305" y="591.04">{{
        $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getMaData.d124) ? (getMaData.d124 === 'н.д.' ? 'н.д.' : 'x') : getMaData.d124, 1, 'float', true, 'н.д.', '', (v) => v + '%')
      }}</tspan></text>
    <line x1="28" y1="655.5" x2="337" y2="655.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="641.16">{{ getMaData.d125name }}</tspan>
      <tspan fill="#0288D1" font-size="12" font-weight="bold"
             v-if="getMaData.d125name !== 'x' && getMaData.d125name !=='н.д.'"
             :data-tooltip="getMaData.d125nameTooltip"
             y="635.16">?</tspan></text>
    <rect x="275" y="617" width="62" height="38" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="305" y="641.04">{{
        $scripts.TableJs.checkValueWithNullAndReturnND(getMaData.d125, 2, 'float', true, 'н.д.', '',)
      }}</tspan></text>
    <path d="M705 311L705 313C705 317.418 708.582 321 713 321L722 321" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M929 311L929 313C929 317.418 925.418 321 921 321L767 321" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M730 332L730 329C730 324.582 726.418 321 722 321L716 321" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M730 332L730 329C730 324.582 733.582 321 738 321L769 321" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="17"
          letter-spacing="0.01em"><tspan x="27" y="158.98">Индикаторы спроса на выпускников
</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="199.22">Показатель</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="276" y="199.22">Значение</tspan></text>
    <line x1="28" y1="207.5" x2="337" y2="207.5" stroke="#B7CED9"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="199.22">Индикатор</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="704" y="199.22">Значение<title>Знак «+» говорит о недостаточности выпускников по УГСН (НПС), знак «-» — об избыточности; число характеризует силу недостаточности/избыточности выпускников (не может превышать 10). Каждая единица в значении индикатора приблизительно соответствует потребности в изменении планового выпуска по УГСН (НПС) на 10%.</title></tspan>
      <tspan xmlns="http://www.w3.org/2000/svg" x="773.581" y="199.22">Точность<title>Штраф за недостаточную точность, применяемый в случае низкой репрезентативности значений показателя, на основе которого рассчитывается частный индикатор (макс. штраф — 2 единицы). Для комплексных индикаторов штраф за точность применяется при наличии разнонаправленных сигналов частных индикаторов.</title></tspan>
      <tspan x="842.63" y="199.22">Итог</tspan>
      <tspan xmlns="http://www.w3.org/2000/svg" x="900.75" y="199.22">Вес<title>Удельный вес частного индикатора, используемый для расчета комплексного индикатора. Если для расчета частного индикатора отсутствуют данные, его вес принимается равным нулю.</title></tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.415em"><tspan x="764.898" y="199.22"> </tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.625em"><tspan x="831.217" y="199.22"> </tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="1.92em"><tspan x="872.502" y="199.22"> </tspan></text>
    <line x1="361" y1="207.5" x2="929" y2="207.5" stroke="#B7CED9"/>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="Red Hat Text" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Удельный вес частного индикатора, используемый для расчета комплексного индикатора. Если для расчета частного индикатора отсутствуют данные, его вес принимается равным нулю." x="926" y="194.278">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="Red Hat Text" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Штраф за недостаточную точность, применяемый в случае низкой репрезентативности значений показателя, на основе которого рассчитывается частный индикатор (макс. штраф — 2 единицы). Для комплексных индикаторов штраф за точность применяется при наличии разнонаправленных сигналов частных индикаторов." x="832" y="194.278">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="Red Hat Text" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Знак «+» говорит о недостаточности выпускников по УГСН (НПС), знак «-» — об избыточности; число характеризует силу недостаточности/избыточности выпускников (не может превышать 10). Каждая единица в значении индикатора приблизительно соответствует потребности в изменении планового выпуска по УГСН (НПС) на 10%." x="765" y="194.278">?</tspan></text>
    
    <line x1="28" y1="256.5" x2="337" y2="256.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="242.16">Удельный вес вакансий</tspan></text>
    <rect x="275" y="218" width="62" height="38" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="310" y="242.04">{{
        $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getMaData.d111) ? (getMaData.d111 === 'н.д.' ? 'н.д.' : 'x') : getMaData.d111, 1, 'float', true, 'н.д.', '', (v) => v + '%')
      }}</tspan></text>
    <line x1="361" y1="256.5" x2="929" y2="256.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="240.685">IdF1</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="402" y="240.685">Индикатор вакансий</tspan></text>
    <rect x="844" y="218" width="50" height="38" fill="#DCE4E8"/>
    <rect x="774" y="218" width="50" height="38" fill="#ECF2F4"/>
    <rect x="705" y="218" width="50" height="38" fill="#ECF2F4"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="18" font-weight="500" letter-spacing="0.01em"><tspan x="869" y="242.92">{{
        getMaData.i111
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="246.2">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="246.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#78909C" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="241.04">{{
        getMaData.p111
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="902" y="252.22">{{
        Number.isNaN(getMaData.w111) ? getMaData.w111 : getMaData.w111 + '%'
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="730" y="241.04">{{
        getMaData.di111
      }}</tspan></text>
    <line x1="361" y1="306.5" x2="929" y2="306.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="290.685">IdF2</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="402" y="290.685">Индикатор трудоустройства
</tspan></text>
    <rect x="844" y="268" width="50" height="38" fill="#DCE4E8"/>
    <rect x="774" y="268" width="50" height="38" fill="#ECF2F4"/>
    <rect x="705" y="268" width="50" height="38" fill="#ECF2F4"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="18" font-weight="500" letter-spacing="0.01em"><tspan x="869" y="292.92">{{
        getMaData.i112
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="296.2">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="30"
          font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="296.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#78909C" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="291.04">{{
        getMaData.p112
      }}</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="902" y="302.22">{{
        Number.isNaN(getMaData.w112) ? getMaData.w112 : getMaData.w112 + '%'
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="730" y="291.04">{{
        getMaData.di112
      }}</tspan></text>
    <line x1="361" y1="381.5" x2="908" y2="381.5" stroke="#99C0DD"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="bold" letter-spacing="0.01em"><tspan x="361" y="347.1">IdF</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="bold" letter-spacing="0.01em"><tspan x="402" y="347.1">Комплексный индикатор</tspan>
      <tspan x="402" y="363.6">дефицита выпускников
</tspan></text>
    <rect x="844" y="333" width="50" height="48" fill="#00599B" fill-opacity="0.28"/>
    <rect x="774" y="333" width="50" height="48" fill="#DEE9F2"/>
    <rect x="705" y="333" width="50" height="48" fill="#00599B" fill-opacity="0.13"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="bold" letter-spacing="0.01em"><tspan x="869" y="363.8">{{
        getMaData.i110
      }}</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="366.2">=</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="366.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="363.8">{{
        getMaData.p110
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="600" letter-spacing="0.01em"><tspan x="730" y="363.8">{{
        getMaData.di110
      }}</tspan></text>
    <line x1="28" y1="306.5" x2="337" y2="306.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="292.16">{{ getMaData.d112name }}</tspan>
      <tspan fill="#0288D1" font-size="12" font-weight="bold"
             v-if="getMaData.d112name !== 'x' && getMaData.d112name !=='н.д.'"
             :data-tooltip="getMaData.d112nameTooltip"
             y="287.16">?</tspan></text>
    <rect x="275" y="268" width="62" height="38" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="310" y="292.04">{{
        getMaData.sprKcpGroupSprUslName === 'магистратура' ? $scripts.TableJs.checkValueWithNullAndReturnND(getMaData.d112, 1, 'float', true, 'н.д.', '') :
            $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getMaData.d112) ? (getMaData.d112 === 'н.д.' ? 'н.д.' : 'x') : getMaData.d112, 1, 'float', true, 'н.д.', '', (v) => v + '%')
      }}</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="17"
          letter-spacing="0.01em"><tspan x="27" y="871.98">Индикаторы предложения выпускников
</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="912.22">Показатель</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="276" y="912.22">Значение</tspan></text>
    <line x1="28" y1="920.5" x2="337" y2="920.5" stroke="#B7CED9"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="361" y="912.22">Индикатор</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="704" y="912.22">Значение<title>Знак «+» говорит о недостаточности выпускников по УГСН (НПС), знак «-» — об избыточности; число характеризует силу недостаточности/избыточности выпускников (не может превышать 10). Каждая единица в значении индикатора приблизительно соответствует потребности в изменении планового выпуска по УГСН (НПС) на 10%.</title></tspan>
      <tspan xmlns="http://www.w3.org/2000/svg" x="773.581" y="912.22">Точность<title>Штраф за недостаточную точность, применяемый в случае низкой репрезентативности значений показателя, на основе которого рассчитывается частный индикатор (макс. штраф — 2 единицы). Для комплексных индикаторов штраф за точность применяется при наличии разнонаправленных сигналов частных индикаторов.</title></tspan>
      <tspan x="842.63" y="912.22">Итог</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.415em"><tspan x="764.898" y="912.22"> </tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.625em"><tspan x="831.217" y="912.22"> </tspan></text>
    <line x1="361" y1="920.5" x2="894" y2="920.5" stroke="#B7CED9"/>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="Red Hat Text" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Штраф за недостаточную точность, применяемый в случае низкой репрезентативности значений показателя, на основе которого рассчитывается частный индикатор (макс. штраф — 2 единицы). Для комплексных индикаторов штраф за точность применяется при наличии разнонаправленных сигналов частных индикаторов."  x="832" y="907.278">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="Red Hat Text" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Знак «+» говорит о недостаточности выпускников по УГСН (НПС), знак «-» — об избыточности; число характеризует силу недостаточности/избыточности выпускников (не может превышать 10). Каждая единица в значении индикатора приблизительно соответствует потребности в изменении планового выпуска по УГСН (НПС) на 10%." x="765" y="907.278">?</tspan></text>
    <line x1="28" y1="979.5" x2="337" y2="979.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="957.36">Выпуск: план/отчет
</tspan></text>
    <rect x="275" y="931" width="62" height="48" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="305" y="960.04">{{
        $scripts.TableJs.checkValueWithNullAndReturnND(getMaData.d211, 2, 'float', true, 'н.д.', '',)
      }}</tspan></text>
    <line x1="361" y1="979.5" x2="908" y2="979.5" stroke="#99C0DD"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="bold" letter-spacing="0.01em"><tspan x="361" y="945.1"/>
      <tspan x="361" y="961.6">IPR
</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="bold" letter-spacing="0.01em"><tspan x="402" y="945.1"/>
      <tspan x="402" y="961.6">Индикатор планового выпуска
</tspan></text>
    <rect x="844" y="931" width="50" height="48" fill="#00599B" fill-opacity="0.28"/>
    <rect x="774" y="931" width="50" height="48" fill="#DEE9F2"/>
    <rect x="705" y="931" width="50" height="48" fill="#00599B" fill-opacity="0.13"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="bold" letter-spacing="0.01em"><tspan x="869" y="961.8">{{
        getMaData.i21
      }}</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="964.2">=</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="964.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="961.8">{{
        getMaData.p211
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="600" letter-spacing="0.01em"><tspan x="730" y="961.8">{{
        getMaData.di211
      }}</tspan></text>
    <line x1="361" y1="1038.5" x2="908" y2="1038.5" stroke="#99C0DD"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="bold" letter-spacing="0.01em"><tspan x="361" y="1004.1">IdD</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="bold" letter-spacing="0.01em"><tspan x="402" y="1004.1">Индикатор избыточности </tspan>
      <tspan x="402" y="1020.6">фактического выпуска
</tspan></text>
    <rect x="844" y="990" width="50" height="48" fill="#00599B" fill-opacity="0.28"/>
    <rect x="774" y="990" width="50" height="48" fill="#DEE9F2"/>
    <rect x="705" y="990" width="50" height="48" fill="#00599B" fill-opacity="0.13"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="bold" letter-spacing="0.01em"><tspan x="869" y="1020.8">{{
        getMaData.i22
      }}</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="827.258" y="1023.2">=</tspan></text>
    <text fill="#00599B" fill-opacity="0.57" xml:space="preserve" style="white-space: pre" font-family="Raleway"
          font-size="30" font-weight="500" letter-spacing="0.01em"><tspan x="758.007" y="1023.2">-</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="500" letter-spacing="0.01em"><tspan x="799" y="1020.8">{{
        getMaData.p221
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="20" font-weight="600" letter-spacing="0.01em"><tspan x="730" y="1020.8">{{
        getMaData.di221
      }}</tspan></text>
    <line x1="28" y1="1038.5" x2="337" y2="1038.5" stroke="#B7CED9"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="28" y="1017.14">∆% удельного веса вакансий
</tspan></text>
    <rect x="275" y="991" width="62" height="47" fill="#DCE4E8"/>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="16" font-weight="500" letter-spacing="0.01em"><tspan x="305" y="1020.04">{{
        $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getMaData.d221) ? (getMaData.d221 === 'н.д.' ? 'н.д.' : 'x') : getMaData.d221, 1, 'float', true, 'н.д.', '', (v) => v + '%')
      }}</tspan></text>
    <line x1="27" y1="123.5" x2="1115" y2="123.5" stroke="#CFD8DC"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="94.4519" y="103.24"><tspan x="27" y="103.24" font-weight="600">{{
        getMaData.sprRegionName
      }}</tspan>, {{ getMaData.sprKcpGroupSprUslName }}: {{ getMaData.sprKcpGroupId }} {{
        getMaData.sprKcpGroupName
      }}</tspan></text>
    <!--  <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16" font-weight="600" letter-spacing="0.01em"><tspan x="27" y="103.24">{{ getMaData.sprRegionName }}.</tspan></text>-->
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22"
          letter-spacing="0.01em"><tspan x="27" y="76.68">Расчет потребности в выпускниках
</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="27" y="40.24">Индикативная модель
</tspan></text>
    <path d="M942 761.021L945.647 764.649C945.842 764.843 946.158 764.843 946.353 764.649L950 761.021" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M927 761.021L930.647 764.649C930.842 764.843 931.158 764.843 931.353 764.649L935 761.021" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M905 381.5L938 381.5C942.418 381.5 946 385.082 946 389.5L946 764.005" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M890 730.5L923 730.5C927.418 730.5 931 734.082 931 738.5L931 764" stroke="#99C0DD" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M942 1069.02L945.647 1072.65C945.842 1072.84 946.158 1072.84 946.353 1072.65L950 1069.02" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M927 1069.02L930.647 1072.65C930.842 1072.84 931.158 1072.84 931.353 1072.65L935 1069.02" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M905 979.5L938 979.5C942.418 979.5 946 983.082 946 987.5L946 1072" stroke="#99C0DD" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M890 1038.5L923 1038.5C927.418 1038.5 931 1042.08 931 1046.5L931 1072" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1013 1153L1016.65 1156.65C1016.84 1156.84 1017.16 1156.84 1017.35 1156.65L1021 1153" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M998 1153L1001.65 1156.65C1001.84 1156.84 1002.16 1156.84 1002.35 1156.65L1006 1153" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M961.5 814.5L1009 814.5C1013.42 814.5 1017 818.082 1017 822.5L1017 1156" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M961 1122.5L994 1122.5C998.418 1122.5 1002 1126.08 1002 1130.5L1002 1155.99" stroke="#99C0DD"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1034 1375L1034 1377C1034 1381.42 1030.42 1385 1026 1385L656.678 1385" stroke="#90A4AE"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M107 1375L107 1377C107 1381.42 110.582 1385 115 1385L484.322 1385" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M570.5 1396L570.5 1393C570.5 1388.58 574.082 1385 578.5 1385L661.337 1385" stroke="#90A4AE"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M570.5 1396L570.5 1393C570.5 1388.58 566.918 1385 562.5 1385L479.663 1385" stroke="#90A4AE"
          stroke-linecap="round" stroke-linejoin="round"/>
    <!-- Индикаторы уровня -->
    <!-- <path d="M484 1257 H570 V1367 H484 V1257 Z" fill="#ECF2F4"/> -->
    <path d="M484 1284H570V1367H484V1284Z" fill="#ECF2F4"/>
    <path xmlns="http://www.w3.org/2000/svg" id="red-indicator" fill="#DEE9F2"
          :d="`M223 1284 H${riH1} V1367 H${riH2} V1284 Z`"/>
    <path :hidden="arrow6Hidden" visibility="[arrow06]"
          d="M196.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M180.469 1281.71V1250.83C180.469 1246.43 184.47 1242.86 189.407 1242.86H200.02M184.938 1278.22L180.864 1281.85C180.646 1282.05 180.292 1282.05 180.074 1281.85L176 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow7Hidden" visibility="[arrow07]"
          d="M282.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M266.469 1281.71V1250.83C266.469 1246.43 270.47 1242.86 275.407 1242.86H286.02M270.938 1278.22L266.864 1281.85C266.646 1282.05 266.292 1282.05 266.074 1281.85L262 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow8Hidden" visibility="[arrow08]"
          d="M369.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M353.469 1281.71V1250.83C353.469 1246.43 357.47 1242.86 362.407 1242.86H373.02M357.938 1278.22L353.864 1281.85C353.646 1282.05 353.292 1282.05 353.074 1281.85L349 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow00Hidden" visibility="[arrow00]"
          d="M456.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M440.469 1281.71V1250.83C440.469 1246.43 444.47 1242.86 449.407 1242.86H460.02M444.938 1278.22L440.864 1281.85C440.646 1282.05 440.292 1282.05 440.074 1281.85L436 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow1Hidden" visibility="[arrow1]"
          d="M543.668 1242.83H999.945M1010 1206V1234.64C1010 1239.16 1006 1242.83 1001.06 1242.83L997.711 1242.83M527.469 1281.7V1251.01C527.469 1246.49 531.47 1242.83 536.407 1242.83H547.02M531.938 1278.12L527.864 1281.85C527.646 1282.05 527.292 1282.05 527.074 1281.85L523 1278.12"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow11Hidden" visibility="[arrow11]"
          d="M630.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M614.469 1281.71V1250.83C614.469 1246.43 618.47 1242.86 623.407 1242.86H634.02M618.938 1278.22L614.864 1281.85C614.646 1282.05 614.292 1282.05 614.074 1281.85L610 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow12Hidden" visibility="[arrow12]"
          d="M717.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M701.469 1281.71V1250.83C701.469 1246.43 705.47 1242.86 710.407 1242.86H721.02M705.938 1278.22L701.864 1281.85C701.646 1282.05 701.292 1282.05 701.074 1281.85L697 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow13Hidden" visibility="[arrow13]"
          d="M804.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M788.469 1281.71V1250.83C788.469 1246.43 792.47 1242.86 797.407 1242.86H808.02M792.938 1278.22L788.864 1281.85C788.646 1282.05 788.292 1282.05 788.074 1281.85L784 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow14Hidden" visibility="[arrow14]"
          d="M891.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M875.469 1281.71V1250.83C875.469 1246.43 879.47 1242.86 884.407 1242.86H895.02M879.938 1278.22L875.864 1281.85C875.646 1282.05 875.292 1282.05 875.074 1281.85L871 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <path :hidden="arrow15Hidden" visibility="[arrow15]"
          d="M978.668 1242.86H999.945M1010 1207V1234.89C1010 1239.29 1006 1242.86 1001.06 1242.86L997.711 1242.86M962.469 1281.71V1250.83C962.469 1246.43 966.47 1242.86 971.407 1242.86H982.02M966.938 1278.22L962.864 1281.85C962.646 1282.05 962.292 1282.05 962.074 1281.85L958 1278.22"
          stroke="#00599B" stroke-linecap="round" stroke-linejoin="round"/>
    <!--  -->
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="138.021" y="1405.72">снижение</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Среднее соотношение числа вакансий и списочной численности работников по группам занятий (должностям), сопряженным с УГСН (НПС)." x="193" y="237.518">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Соотношение среднегодового расчетного выпуска вузов по УГСН (НПС) в прогнозном и отчетном периодах, нацеленного на трудоустройство в регионе." x="166" y="953.518">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Среднее изменение соотношения числа вакансий и списочной численности работников по группам занятий (должностям), сопряженным с УГСН (НПС), за отчетный период (4 года)." x="227" y="1012.52">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Средний ожидаемый прирост потребности по группам занятий (должностям), сопряженным с УГСН (НПС) (в соответствии с опросом крупнейших работодателей региона, ассоциаций работодателей и иных экспертов)." x="267" y="586.518">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Прогнозируемый прирост численности населения возрастов, соответствующих основным потребителям услуг по отраслям, сопряженным с УГСН (НПС)." x="252" y="536.518">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Среднее соотношение числа новых рабочих мест и списочной численности работников крупных и средних организаций по сопряженным УГСН (НПС) группам занятий (должностям)." x="259" y="487.518">?</tspan></text>
    <text fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12"
          font-weight="bold" letter-spacing="0em"><tspan data-tooltip="Средний годовой темп роста по отраслям, сопряженным с УГСН (НПС), в соответствии с долгосрочным прогнозом социально-экономического развития региона." x="257" y="437.518">?</tspan></text>
    <path d="M397 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="341.268" y="1352.65">0,8</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="317.641" y="1307.09">умеренное </tspan>
      <tspan x="321.02" y="1320.09">снижение</tspan></text>
    <path d="M658 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="605.51" y="1352.65">1,1</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="590.719" y="1307.09">слабый
</tspan>
      <tspan x="599.558" y="1320.09">рост</tspan></text>
    <path d="M919 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="865.424" y="1352.65">1,4</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="848.264" y="1307.09">сильный </tspan>
      <tspan x="860.558" y="1320.09">рост</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="952.58" y="1352.65">1,5</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="943.938" y="1300.59">очень </tspan>
      <tspan x="935.264" y="1313.59">сильный
</tspan>
      <tspan x="947.558" y="1326.59">рост</tspan></text>
    <path d="M310 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="254.776" y="1352.65">0,7</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="231.733" y="1300.59">умеренно-
</tspan>
      <tspan x="239.982" y="1313.59">сильное </tspan>
      <tspan x="234.02" y="1326.59">снижение</tspan></text>
    <path d="M571 1367V1284" stroke="#90A4AE"/>
    <path d="M484 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="516.518" y="1352.65">1,0</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="bold" letter-spacing="0.01em">
	<tspan x="496.467" y="1305">Текущий</tspan>
      <tspan x="498.388" y="1320">уровень</tspan>
</text>
    <path d="M832 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="778.362" y="1352.65">1,3</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="753.733" y="1300.59">умеренно-
</tspan>
      <tspan x="761.264" y="1313.59">сильный </tspan>
      <tspan x="773.558" y="1326.59">рост</tspan></text>
    <path d="M223 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="167.198" y="1352.65">0,6</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="152.982" y="1307.09">сильное </tspan>
      <tspan x="147.02" y="1320.09">снижение</tspan></text>
    <path d="M484 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="428.198" y="1352.65">0,9</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="417.436" y="1307.09">слабое </tspan>
      <tspan x="408.02" y="1320.09">снижение</tspan></text>
    <path d="M745 1367V1284" stroke="#90A4AE"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          font-weight="500" letter-spacing="0.01em"><tspan x="691.323" y="1352.65">1,2</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="664.924" y="1307.09">умеренный </tspan>
      <tspan x="686.558" y="1320.09">рост</tspan></text>
    <path d="M1028 1395L1018.77 1404.23L1014.92 1400.38L1008 1407.31M1028 1395V1401.15M1028 1395H1021.85"
          stroke="#78909C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14"
          font-weight="500" letter-spacing="0.01em"><tspan x="968.408" y="1405.72">рост</tspan></text>
    <path d="M113 1407.31L122.231 1398.08L126.077 1401.92L133 1395M113 1407.31V1401.15M113 1407.31H119.154"
          stroke="#78909C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <!-- ///////////////////////    длинная строка вычислений в конце блока  /////////////////////////////  -->
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47"
          letter-spacing="0.01em">
      <tspan :x="Math.abs(getMaData.rv) > 100 ? 120 : 145" y="1464.18">{{ getMaData.rv }}</tspan>
    </text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em">
      <tspan x="100" y="1491.22">Плановый выпуск</tspan>
      <tspan x="100" y="1507.46">{{ getMaData.yyy0 }}-{{ getMaData.yyy1 }} годов</tspan>
    </text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="46.5581" letter-spacing="0.01em">
      <tspan x="230" y="1458.76">×</tspan>
    </text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="270" y="1491.22">Коэффициент</tspan>
      <tspan x="270" y="1507.46">изм. потребности</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47"
          letter-spacing="0.01em">
      <tspan x="285" y="1460.18">{{
          $scripts.TableJs.checkValueWithNullAndReturnND(getMaData.ki, 1, 'float', true, 'н.д.', '',)
        }}</tspan>
    </text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="46.5581" letter-spacing="0.01em">
      <tspan x="390" y="1458.76">+</tspan>
    </text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em">
      <tspan xmlns="http://www.w3.org/2000/svg" x="430" y="1491.22">Балансировка</tspan>
      <tspan xmlns="http://www.w3.org/2000/svg" x="430" y="1507.46">по УГСН (НПС)</tspan>
    </text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47"
          letter-spacing="0.01em"><tspan :x="Math.abs(getMaData.ibw) > 100 ? 430 : 455" y="1460.18">{{
        (!Number.isNaN(getMaData.ibw) && (!(getMaData.ibw >= 0))) ? '(' : ''
      }}{{ getMaData.ibw }}{{
        (!Number.isNaN(getMaData.ibw) && (!(getMaData.ibw >= 0))) ? ')' : ''
      }}</tspan>
    </text>
    <text
      fill="#0288D1" xml:space="preserve" style="white-space: pre"
      font-family="PT Serif" font-size="12" font-weight="bold" letter-spacing="0em">
      <tspan data-tooltip="Изменение объема прогнозируемой потребности в подготовке кадров для региона
       в целях обеспечения равенства суммы потребности по регионам сумме прогнозной потребности по УГСН (НПС)." x="525"
             y="1501.52">?</tspan>
    </text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="46.5581" letter-spacing="0.01em"><tspan x="550" y="1458.76">=</tspan>
    </text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="47" font-weight="bold" letter-spacing="0.01em">
      <tspan :x="Math.abs(getMaData.pv) > 100 ? 605 : 625" y="1460.18">{{ getMaData.pv }}</tspan>
    </text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="605" y="1491.22">Потребность </tspan>
      <tspan x="605" y="1507.46">в подготовке</tspan>
    </text>
    <text v-if="getMaData.cor !== 'x'" fill="#263238" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="46.5581" letter-spacing="0.01em"><tspan x="720" y="1458.76">+</tspan>
    </text>
    <text v-if="getMaData.cor !== 'x'" fill="#263238" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="47" letter-spacing="0.01em">
      <tspan x="765" y="1460.18"> {{ getMaData.cor }}</tspan>
    </text>
    <text v-if="getMaData.cor !== 'x'"  fill="#263238" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em">
      <tspan v-if="getMaData.cor !== 'x'" x="750" y="1491.22">Корректировка</tspan>
      <tspan v-if="getMaData.cor !== 'x'" x="750" y="1507.46">субъекта России</tspan>
    </text>
    <text v-if="getMaData.cor !== 'x'"  fill="#263238" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="46.5581" letter-spacing="0.01em"><tspan x="870" y="1458.76">=</tspan>
    </text>
    <text v-if="getMaData.cor !== 'x'"  fill="#00599B" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="47" letter-spacing="0.01em">
      <tspan v-if="getMaData.cor !== 'x'" x="950" y="1460.18">{{ getMaData.pvc }}</tspan>
    </text>
    <text
      v-if="getMaData.cor !== 'x'" fill="#0288D1" xml:space="preserve" style="white-space: pre"
      font-family="PT Serif" font-size="12" font-weight="bold" letter-spacing="0em">
      <tspan v-if="getMaData.cor !== 'x'" :data-tooltip="`Заявленная регионом потреность - ${getMaData.pvz}.
       Скорректированная потребность с учетом границ диапазона от 0,6 до 1,5 от среднегопланового выпуска,
        нацеленного на трудоустройство в регионе - ${getMaData.pvc}`" x="1050" y="1480">?</tspan>
    </text>
    <text v-if="getMaData.cor !== 'x'" fill="#00599B" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em">
      <tspan v-if="getMaData.cor !== 'x'" x="910" y="1491.22">Скорректированная</tspan>
      <tspan v-if="getMaData.cor !== 'x'" fill="#00599B" x="940" y="1507.46">потребность</tspan>
    </text>
    <!-- ^^^^^^^^^^^^^^^^^^    длинная строка вычислений в конце блока  ^^^^^^^^^^^^^^^^^^  -->
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="600" letter-spacing="0.01em"><tspan x="491" y="1617.63">Отклонение</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="600" letter-spacing="0.01em"><tspan xmlns="http://www.w3.org/2000/svg" x="810" y="1618.1" text-anchor="end">{{
        getMaData.pv0df > 0 ? '+' : ''
      }}{{
        $scripts.TableJs.formatNumberToRuFormat(getMaData.pv0df)
      }}</tspan></text>
    <line x1="490" y1="1599.5" x2="816" y2="1599.5" stroke="#CFD8DC"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="491" y="1590.63">Сумма потребности по регионам</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="15"
          font-weight="500" letter-spacing="0.01em"><tspan xmlns="http://www.w3.org/2000/svg" x="810" y="1591.1" text-anchor="end">{{
        $scripts.TableJs.formatNumberToRuFormat(getMaData.pv0sr)
      }}</tspan></text>
    <line x1="490" y1="1572.5" x2="816" y2="1572.5" stroke="#CFD8DC"/>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="491" y="1563.63">Потребность по УГСН (НПС)</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" fill="#263238" xml:space="preserve" style="white-space: pre"
          font-family="Raleway" font-size="15" font-weight="500" letter-spacing="0.01em"><tspan x="810" y="1564.1" text-anchor="end">{{
        $scripts.TableJs.formatNumberToRuFormat(getMaData.pv0ug)
      }}</tspan></text>
    <path d="M819 1542L819 1540C819 1535.58 815.418 1532 811 1532L768.935 1532" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M490 1542L490 1540C490 1535.58 493.582 1532 498 1532L540.065 1532" stroke="#90A4AE" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path d="M654.5 1521L654.5 1524C654.5 1528.42 658.082 1532 662.5 1532L771.319 1532" stroke="#90A4AE"
          stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M654.5 1521L654.5 1524C654.5 1528.42 650.918 1532 646.5 1532L537.681 1532" stroke="#90A4AE"
          stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import request from "@/services/request";
import {svgPropsMapper} from "@/mixins/svgPropsMapper";

export default {
  name: "MaSvgRegion",
  mixins: [svgPropsMapper],
  props: {
    kcpGroupId: null,
    regionId: null,
  },
  data() {
    return {
      getMaData: {
        id: 0,
        sprKcpGroupId: "string",
        sprKcpGroupName: "string",
        sprKcpGroupSprUslName: "string",
        sprRegionId: "string",
        sprRegionName: "string",
        sprRegionNameGenitive: "string",
        d111: 0,
        di111: "string",
        w111: 0,
        p111: 0,
        i111: "string",
        d112: 0,
        d112name: "string",
        d112name1: "string",
        d112name2: "string",
        di112: "string",
        w112: 0,
        p112: 0,
        i112: "string",
        di110: "string",
        p110: 0,
        i110: "string",
        d121: 0,
        di121: "string",
        w121: 0,
        p121: 0,
        i121: "string",
        d122: 0,
        di122: "string",
        w122: 0,
        p122: 0,
        i122: "string",
        d123: 0,
        di123: "string",
        w123: 0,
        p123: 0,
        i123: "string",
        d124: 0,
        di124: "string",
        w124: 0,
        p124: 0,
        i124: "string",
        d125: 0,
        d125name: "string",
        d125name1: "string",
        d125name2: "string",
        di125: "string",
        w125: 0,
        p125: 0,
        i125: "string",
        di120: "string",
        p120: 0,
        i120: "string",
        i1: "string",
        d211: 0,
        di211: "string",
        p211: 0,
        i21: "string",
        d221: 0,
        di221: "string",
        p221: 0,
        i22: "string",
        i2: "string",
        di0: "string",
        p0: 0,
        ki: 0,
        yyy0: 0,
        yyy1: 0,
        rv: 0,
        pv: 0,
        ibw: 0,
        pv0df: 0,
        pv0sr: 0,
        pv0ug: 0,
        d112nameTooltip: 'string',
        d125nameTooltip: 'string',
      },
      ki: 1,
      riH1: 1,
      riH2: 1,
      arrow6Hidden: true,
      arrow7Hidden: true,
      arrow8Hidden: true,
      arrow00Hidden: true,
      arrow1Hidden: true,
      arrow11Hidden: true,
      arrow12Hidden: true,
      arrow13Hidden: true,
      arrow14Hidden: true,
      arrow15Hidden: true,
    }
  },
  async created() {
    await this.getMaSvg();
  },
  methods: {
    async getMaSvg() {
      try {
        const res = await request({
          endpoint: `/api/information/getMa?kcpGroupId=${this.kcpGroupId}&regionId=${this.regionId}`,
          method: 'get',
        });
        if (res.status === 200) {
          console.log('getMaSvg Region успех');
          if (res.data) {
            this.mapServerData(res.data);
            this.getMaData.d112nameTooltip = this.getMaData?.d112name === '% трудоустройства' ?
              'Процент трудоустройства выпускников по УГСН (НПС) (граждане РФ, очная форма обучения, без учета продолживших обучение), в году, следующем за годом выпуска (за 3 отчетных года). Трудоустроенным считался выпускник, имевший заработную плату в размере более 1 прожиточного минимума, либо зарегистрированный в качестве предпринимателя, самозанятого.' :
              'Среднее соотношение заработной платы выпускников по УГСН (НПС), полученной в году, следующем за годом выпуска, к прожиточному минимуму в регионе трудоустройства (за 3 отчетных года).';
            this.getMaData.d125nameTooltip = this.getMaData?.d125name === 'Балл ЕГЭ к среднему по региону' ?
              'Соотношение среднего балла ЕГЭ студентов, поступивших по УГСН (НПС) по очной форме обучения, и среднего значения по всем УГСН (НПС), по вузам  региона.' :
              'Соотношение численности абитуриентов, подавших заявление на поступление, и численности абитуриентов, принятых на обучение по УГСН (НПС), по очной форме обучения, по вузам региона.';
          } else
            this.mapServerData();
          // const getMaDataKeys = Object.keys(this.getMaData);
          // const getMaDataValues = Object.values(this.getMaData);
          // for (let i = 0; i < getMaDataValues.length; i++) {
          //   if (getMaDataValues[i] === null) { // проставление 0 вместо null из базы, чтобы значение было визуально видно
          //     this.getMaData[getMaDataKeys[i]] = 0;
          //   }
          // }
          this.ki = this.getMaData?.ki;
          if (this.ki === 0.6) {
            this.arrow6Hidden = false;
            this.riH1 = 223;
            this.riH2 = 135;
          }
          if (this.ki === 0.7) {
            this.arrow7Hidden = false;
            this.riH1 = 309;
            this.riH2 = 223;
          }
          if (this.ki === 0.8) {
            this.arrow8Hidden = false;
            this.riH1 = 396;
            this.riH2 = 310;
          }
          if (this.ki === 0.9) {
            this.arrow00Hidden = false;
            this.riH1 = 483;
            this.riH2 = 397;
          }
          if (this.ki === 1) {
            this.arrow1Hidden = false;
            this.riH1 = 570;
            this.riH2 = 483;
          }
          if (this.ki === 1.1) {
            this.arrow11Hidden = false;
            this.riH1 = 657;
            this.riH2 = 570;
          }
          if (this.ki === 1.2) {
            this.arrow12Hidden = false;
            this.riH1 = 744;
            this.riH2 = 657;
          }
          if (this.ki === 1.3) {
            this.arrow13Hidden = false;
            this.riH1 = 831;
            this.riH2 = 744;
          }
          if (this.ki === 1.4) {
            this.arrow14Hidden = false;
            this.riH1 = 918;
            this.riH2 = 831;
          }
          if (this.ki === 1.5) {
            this.arrow15Hidden = false;
            this.riH1 = 1005;
            this.riH2 = 918;
          }
        }
        this.changeDefaultValues();
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700');

text {
  font-feature-settings: 'pnum' on, 'lnum' on;
}
</style>